export const TYPE_TEXT = "text";
export const TYPE_HTML = "html";
export const TYPE_POLOPOLY_SIMILAR = "polopoly_similar";
export const TYPE_POLOPOLY_IMAGE = "polopoly_image";
export const TYPE_POLOPOLY_EMBED = "polopoly_embed";
export const TYPE_POLOPOLY_MEDIA = "polopoly_media";
export const TYPE_POLOPOLY_PHOTOGALLERY = "polopoly_photogallery";
export const TYPE_POLOPOLY_CUSTOM = "polopoly_custom";

export const TYPE_POLOPOLY_EMBED_YOUTUBE = "youtube";
export const TYPE_POLOPOLY_EMBED_FACEBOOK = "facebookvideo";
export const TYPE_POLOPOLY_EMBED_SCRIBBLELIVE = "scribblelive";
export const TYPE_POLOPOLY_EMBED_FACEBOOK_POST = "facebookpost";
export const TYPE_POLOPOLY_EMBED_HTML = "customhtml";
export const TYPE_POLOPOLY_EMBED_TWIITER = "twitter";
export const TYPE_POLOPOLY_EMBED_DOCUMENTCLOUD = "documentcloud";
export const TYPE_POLOPOLY_EMBED_INSTAGRAM = "instagram";
export const TYPE_POLOPOLY_EMBED_CARDCAROUSEL = "cardcarousel";
export const TYPE_POLOPOLY_EMBED_DATAWRAPPER = "datawrapper";

export const TAG_BLOCKQUOTE = "blockquote";

export const DERIVATIVE_WIDTHS = [300, 460, 620, 780, 1180];
